import { render } from "./CustomTab.vue?vue&type=template&id=7388d63e"
import script from "./CustomTab.vue?vue&type=script&lang=ts"
export * from "./CustomTab.vue?vue&type=script&lang=ts"
script.render = render

export default script